import script from "./misteryBoxView.vue?vue&type=script&setup=true&lang=ts"
export * from "./misteryBoxView.vue?vue&type=script&setup=true&lang=ts"

import "./misteryBoxView.vue?vue&type=style&index=0&id=2677a1ab&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2677a1ab"]])

export default __exports__